export const typeMap = {
  option: "test_option_id",
  checkbox: "test_option_ids",
  text: "text"
};
